import { REQUIRED_TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { object, ObjectSchema } from 'yup';

type CreateTransactionValidationSchemaType = {
  name: string;
};

export const createTransactionValidationSchema: ObjectSchema<CreateTransactionValidationSchemaType> = object().shape({
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
});
